import { CERelationshipBase } from './ce-relationship-base'


export class CERelationship extends CERelationshipBase {

}